
import { useEffect, useState } from "react";

export default function Experience() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const experiences = [
    {
  company: "SevaAI",
  technologies: [
    "React",
    "Next-JS",
    "Material UI",
    "PostgreSQL",
    "Prisma",
    "AWS",
    "Azure DevOps"
  ],
  website: "http://3.6.173.244:5053/",
  duration: "4 months",
  description:
    "SevaAI is a hospitality management platform providing a complete ERP suite for hotels and restaurants, enabling automation of procurement, inventory, finance, and accounting processes.",
  
  achievements: [
    "Designed and developed a full-scale Hotel ERP system including company, branch, and restaurant management modules to streamline multi-location operations.",
    "Built a robust Material Management System supporting multiple inventory valuation methods such as FIFO, LIFO, Standard Cost, and Moving Average Price, ensuring accurate stock and cost reporting.",
    "Implemented the complete Procurement Lifecycle including Purchase Requisition (PR), Purchase Order (PO), Goods Receipt (GR), and Invoice modules with configurable approval workflows.",
    "Developed secure approval mechanisms for PR and PO to manage role-based authorization in the procurement chain.",
     
    // ⬇ Your newly added professional experience points
    "Developed the Chart of Accounts module enabling users to create, manage, and categorize financial accounts following accounting standards.",
    "Built a fully functional Ledger Book Entry module allowing journal entries, debit/credit tracking, and real-time financial updates.",
    "Integrated the Material Management (MM) module with the ledger system—automatically updating relevant ledgers immediately after Goods Receipt (GR) entries.",
    "Implemented a comprehensive Bank Module supporting creation and management of bank accounts with full transaction tracking.",
    "Developed the Bank Transaction Module with complete withdrawal and deposit workflows, ensuring accurate financial posting.",
    "Built the Cheque Entry and Reconciliation system, enabling cheque issuance, tracking, clearing status updates, and reconciliation against bank statements.",
    "Designed and implemented the Bank Ledger and Bank Reconciliation Ledger modules for accurate financial reporting and monthly reconciliation."
  ]
},

    {
      company: "PROPVATOR",
      technologies: ["React", "Next-JS", "Tailwind CSS", "WordPress", "Vercel"],
      website: "https://propvator.com",
      duration: "3 months",
      description: "Propvator is an online platform that provides users with a list of various proprietary trading firms, aiming to educate users by sharing publicly available information sourced online. Our mission is to promote transparency, enabling users to make informed decisions when choosing a proprietary trading firm",
      achievements: [
        "Developed a new offer page with a custom-designed, responsive table layout, integrating dynamic data using Next.js and React for enhanced performance and seamless interaction.",
        "Designed and implemented the home page based on Figma specifications, incorporating advanced gradient effects and animation features to deliver a visually engaging user experience.",
        "Ensured full responsiveness across all screen sizes, maintaining consistent design and usability on both desktop and mobile devices.",
        "Designed and developed the blog page using WordPress with dynamic post display functionality for streamlined content management.",
        "Implemented and customized styles using CSS, integrating the design through a custom CSS file within the child theme for maintainability and theme integrity."
      ]
    },
    {
      company: "FOTO-AGENTUR",
      technologies: ["Express-JS", "Vue-JS", "Bootstrap", "CSS", "MySQL"],
      website: "https://meine.foto-agentur.de/app/ticket",
      duration: "1 month",
      description: "Foto-agentur is a platform to showcase and sell a photographer's work, attract clients, and build a professional brand. It acts as a digital portfolio, allowing photographers to present their best images, connect with potential clients, and potentially sell prints or digital downloads",
      achievements: [
        "Designed and implemented new database tables to efficiently store and retrieve user data for messaging functionality.",
        "Contributed to backend development, enabling seamless integration of the messaging system within the platform.",
        "Developed a real-time conversation interface between admins and users with a focus on intuitive and user-friendly UI design.",
        "Ensured full mobile responsiveness of the messaging system to maintain a consistent and accessible user experience across all devices.",
        "Implemented API endpoints and optimized database queries to ensure fast message delivery and retrieval with minimal latency."
      ]
    },
    {
      company: "GRUNDSCHULSHIRTS",
      technologies: ["React-JS", "Tailwind CSS"],
      website: "https://grundschulshirts.de/",
      duration: "4 months",
      description: "Grundschulshirts is a custom T-shirt eCommerce platform enabling users to upload and order shirts with their preferred image prints",
      achievements: [
        "Designed and implemented a fully responsive T-shirt customization page with image preview and variant selection for both front and back views.",
        "Integrated login authentication and real-time image fitting functionality for a seamless user experience.",
        "Collaborated with backend teams to enable email notifications with selected T-shirt designs and user details.",
        "Ensured cross-device compatibility with responsive UI design across mobile, tablet, and desktop platforms."
      ]
    },
    {
      company: "KORKHAII",
      technologies: ["Node", "Express-JS", "MongoDB", "React-JS", "Bootstrap"],
      duration: "5 months",
      description: "Korkhaii is a cryptocurrency platform enabling users to trade, deposit, withdraw, and purchase commission-based plans on daily, weekly, monthly, and yearly cycles",
      achievements: [
        "Developed the application from scratch, implementing a robust user management system with JWT-based authentication and JOI validation.",
        "Designed and built secure withdrawal and deposit functionalities, storing transaction data in MongoDB using Mongoose queries.",
        "Created and integrated staking purchase plans and swap wallet transfer features to boost user engagement and platform functionality.",
        "Developed and optimized RESTful APIs for both admin and user interfaces, ensuring high performance, security, and a seamless user experience."
      ]
    },
    {
      company: "BOOKINGFLIX",
      technologies: ["Vue-JS", "Vuex", "Bootstrap"],
      duration: "10 months",
      description: "Bookingflix is an event booking platform allowing users to reserve seats based on date, time, and seat arrangement, supporting both hourly and daily bookings.",
      achievements: [
        "Developed an event booking interface within the admin dashboard to streamline backend operations and improve overall efficiency.",
        "Created an interactive seat arrangement system with real-time selection and integrated bucket timing logic for optimized scheduling.",
        "Designed and implemented a dynamic, user-friendly calendar interface to enable seamless booking experiences.",
        "Integrated secure payment functionalities and ensured fully mobile-responsive UI designs to enhance accessibility across all devices."
      ]
    }
  ];

  const websites = [
    "https://poweredbygreenbox.com/",
    "https://abhadley.com/",
    "https://www.wesbarvanquip.com.au/",
    "https://hivekids.com.au/",
    "https://leanraqa.com/",
    "https://covertlawenforcement.com/",
    "https://northernutahglass.com/"
  ];

  return (
    <section id="services" className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden py-20">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className={`text-center mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Professional{" "}
            <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              Experience
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            A journey through diverse projects and technologies, delivering innovative solutions across various domains
          </p>
        </div>

        {/* Experience Timeline */}
        <div className="space-y-12">
          {experiences.map((exp, index) => (
            <div key={index} className={`transition-all duration-1000 delay-${(index + 1) * 200} ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
                {/* Company Header */}
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-2">
                      {exp.company}
                    </h3>
                    <p className="text-gray-400 mb-2">{exp.description}</p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {exp.technologies.map((tech, techIndex) => (
                        <span key={techIndex} className="px-3 py-1 bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30 rounded-full text-sm text-blue-300">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="lg:text-right">
                    <div className="text-lg font-semibold text-purple-400 mb-2">
                      {exp.duration}
                    </div>
                    {exp.website && (
                      <a 
                        href={exp.website} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors duration-300"
                      >
                        <span>Visit Website</span>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>

                {/* Achievements */}
                <div className="space-y-3">
                  <h4 className="text-lg font-semibold text-white mb-4">Key Achievements:</h4>
                  {exp.achievements.map((achievement, achievementIndex) => (
                    <div key={achievementIndex} className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-300 leading-relaxed">{achievement}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* UI Design & Performance Section */}
        <div className={`mt-20 transition-all duration-1000 delay-1200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
            <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent text-center">
              Responsive UI Design & Frontend Performance Optimization
            </h3>
            
            {/* Websites Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
              {websites.map((website, index) => (
                <a 
                  key={index}
                  href={website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group p-4 bg-gradient-to-br from-blue-500/10 to-purple-500/10 border border-blue-500/20 rounded-xl hover:border-blue-400/40 transition-all duration-300"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full group-hover:scale-150 transition-transform duration-300"></div>
                    <span className="text-gray-300 group-hover:text-white transition-colors duration-300 text-sm">
                      {website.replace(/^https?:\/\//, '').replace(/\/$/, '')}
                    </span>
                  </div>
                </a>
              ))}
            </div>

            {/* Performance Achievements */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-white mb-3">Design & Development</h4>
                <ul className="space-y-2 text-gray-300">
                  <li className="flex items-start space-x-3">
                    <span className="text-blue-400 mt-1">•</span>
                    <span>Designed and developed fully responsive UI pages for the websites, ensuring seamless experience across all screen sizes</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-blue-400 mt-1">•</span>
                    <span>Utilized LT Browser to test and validate layouts, spacing, and responsiveness on various devices and resolutions</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-blue-400 mt-1">•</span>
                    <span>Ensured consistent design, optimized spacing, and cross-device compatibility to enhance user experience</span>
                  </li>
                </ul>
              </div>
              
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-white mb-3">Performance Optimization</h4>
                <ul className="space-y-2 text-gray-300">
                  <li className="flex items-start space-x-3">
                    <span className="text-purple-400 mt-1">•</span>
                    <span>Reviewed performance metrics using PageSpeed Insights and GTmetrix, identifying key issues affecting load time and SEO</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-purple-400 mt-1">•</span>
                    <span>Optimized assets by converting images to WebP, minifying CSS/JS, resizing banners, and implementing lazy loading</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-purple-400 mt-1">•</span>
                    <span>Improved page performance by deferring non-critical JavaScript and preloading critical CSS to enhance initial render speed</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 